import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Spinner,
  Flex,
  useToast,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import axios from '../../axiosConfig';
import { useUser } from '../../contexts/UserContext';
import ArticleReadPage from './ArticleReadPage';

const ArticlePreviewPage = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const toast = useToast();
  const { user } = useUser();

  const isAdminOrTech = user?.role === 'admin' || user?.role === 'tech';

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const res = await axios.get(`/admin/articles/${id}`);
        setArticle(res.data);
      } catch (err) {
        toast({
          title: 'Failed to load article.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id, toast]);

  const togglePublish = async () => {
    if (!article) return;
    setUpdating(true);
    try {
      const action = article.published_at ? 'unpublish' : 'publish';
      const res = await axios.patch(`/admin/articles/${article.id}/${action}`);
      setArticle(res.data);
      toast({
        title: `Article ${res.data.published_at ? 'published' : 'unpublished'} successfully.`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: 'Failed to update article status.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <Flex justify="center" align="center" minH="50vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Flex direction="column" minH="100vh">
      {isAdminOrTech && (
        <>
          <Box maxW="container.lg" mx="auto" mt={4} px={4}>
            <Button
              colorScheme={article?.published_at ? 'red' : 'green'}
              onClick={togglePublish}
              variant="outline"
              isLoading={updating}
            >
              {article?.published_at ? 'Unpublish' : 'Publish'}
            </Button>
          </Box>
          <Box w="100%" h="1px" mt={4} bgGradient="linear(to-r, #A2BA06, #4EB9C5, #E5923B)" />
        </>
      )}
      <Box flex="1">
        <ArticleReadPage article={article} />
      </Box>
    </Flex>
  );
};

export default ArticlePreviewPage;